














import { defineComponent, onUnmounted } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import RewardPane from '@/components/RewardPage/RewardPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import useRewards from '@/store/hook/videoPlatformContents/useRewards'

export default defineComponent({
  name: 'RewardPage',
  components: { GlobalNavigationPane, RewardPane, HeaderPane },
  setup() {
    const { clearRewards } = useRewards()

    onUnmounted(() => {
      clearRewards()
    })
  },
})
